import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"
import { useLayerCategoryLayerAddMutation } from "@/v2-backoffice-client/layer/category/layer/add/layer.category.layer.add.mutation"

export type LayerCategoryLayerAddLayerSelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect"
> & {
  layer: LayerFragment
  categoryFeatureCode: string
  onSelect?(): void
}

function LayerCategoryLayerAddLayerSelectorItem(
  props: LayerCategoryLayerAddLayerSelectorItemProps,
) {
  const { layer, categoryFeatureCode, onSelect, ...selectorItemProps } = props

  const [select, { loading, error }] = useLayerCategoryLayerAddMutation()
  errorToast(error, {
    title: "Failed to add layer to category",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={`${layer.Name ?? layer.FeatureCode} ${layer.FeatureCode} ${layer.LayerTypeCode}`}
      onSelect={() => {
        select({
          variables: {
            layerFeatureCode: layer.FeatureCode,
            categoryFeatureCode,
          },
        })
        onSelect?.()
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        primary={layer.Name ?? layer.FeatureCode}
        secondary={`${layer.FeatureCode} -- ${layer.LayerTypeCode}`}
      />
    </Selector.Item>
  )
}

export default LayerCategoryLayerAddLayerSelectorItem
